import apiConfig from '../data/api.json';
import apiMockConfig from '../data/api-mock.json';
import baseURLConfig from '../data/api-baseurl.json';

interface ApiConfig {
  baseURL: string;
  latencyMs: number;
  debug?: boolean;
  endpoints: {
    [key: string]: {
      [key: string]: string;
    };
  };
}

const isMockEnabled = (): boolean => {
  return import.meta.env.VITE_ENABLE_MOCK === 'true';
};

const getBaseURL = (): string => {
  const config = baseURLConfig as Record<string, string>;

  if (typeof window === 'undefined') {
    return config.default;
  }

  const hostname = window.location.hostname;
  return config[hostname] || config.default;
};

export const getApiConfig = (): ApiConfig => {
  const endpoints = isMockEnabled()
    ? apiMockConfig.endpoints
    : apiConfig.endpoints;

  return {
    baseURL: getBaseURL(),
    latencyMs: apiConfig.latencyMs,
    debug: apiConfig.debug,
    endpoints: endpoints as ApiConfig['endpoints']
  };
};

export const getEndpointUrl = (category: string, endpoint: string): string => {
  const config = getApiConfig();
  const path = config.endpoints[category]?.[endpoint];

  if (!path) {
    throw new Error(`Endpoint not found: ${category}.${endpoint}`);
  }

  if (path.startsWith('http:') || path.startsWith('https:')) {
    return path;
  }

  if (isMockEnabled()) {
    return path;
  }

  return `${config.baseURL}${path}`;
};
